import { Heading } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { RightOfOccupancyFeeWaitingForRefund } from '../../../../../common/generated/residentApiSchemas'
import { Divider } from '../../Divider'
import { localizeCurrency } from '../../utils'
import { FeeBreakdown } from '../FeeBreakdown/FeeBreakdown'
import { FeeRow } from '../FeeRow/FeeRow'
import { FeeTotalRow } from '../FeeTotalRow/FeeTotalRow'
import { InfoNotification } from '../InfoNotification/InfoNotification'
import { PaidFee } from '../PaidFee/PaidFee'

import { formatDate } from 'utils/dateUtils'

export const WaitingForRefundRightOfOccupancyFee: React.FC<{
  fee: RightOfOccupancyFeeWaitingForRefund
}> = ({ fee }) => {
  const { t } = useTranslation(['payments'])
  const hasWithholdingsOrRefunds =
    fee.withholdings.length > 0 || fee.refunds.length > 0

  return (
    <>
      <InfoNotification
        text={t('payments:rightOfOccupancyFee.finalCalculationNotice')}
      />
      <FeeBreakdown
        breakdown={fee.valueAtTermination}
        title={t('payments:rightOfOccupancyFee.valueAtTerminationTitle')}
        indexInfoKey="payments:rightOfOccupancyFee.valueAtTerminationIndexInfo"
        totalLabel={t('payments:rightOfOccupancyFee.valueAtTermination')}
      />
      <PaidFee paidAmount={fee.paidAmount} paidDate={fee.paidDate} />
      {hasWithholdingsOrRefunds && (
        <section>
          <Divider className="mt-6 mb-6" />
          <Heading element="h2" size="m" bold className="mb-2">
            {t('payments:rightOfOccupancyFee.withholdingsAndRefundsTitle')}
          </Heading>
          {fee.withholdings.map((withholding, index) => (
            <FeeRow
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={`withholding-${index}`}
              label={t('payments:rightOfOccupancyFee.withholding', {
                description: withholding.description,
              })}
              value={`− ${localizeCurrency(withholding.amount)}`}
            />
          ))}
          {fee.refunds.map((refund, index) => (
            <FeeRow
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={`refund-${index}`}
              label={t('payments:rightOfOccupancyFee.refund', {
                date: formatDate(refund.date),
              })}
              value={`− ${localizeCurrency(refund.amount)}`}
            />
          ))}
          <Divider />
          <FeeTotalRow
            label={t('payments:rightOfOccupancyFee.remainingValue')}
            value={localizeCurrency(fee.remainingValue)}
          />
        </section>
      )}
    </>
  )
}
